import * as React from "react";
import equal from "fast-deep-equal/es6";

const AnnotationGeometry = ({ annotation, addGeometry }): null => {
  const geoRef = React.useRef(null);

  const {
    id,
    label,
    color,
    geometry: rawGeometry,
    layer: { render_properties },
  } = annotation;

  const rawPaint = React.useMemo(() => {
    if (annotation.color) {
      return { ...render_properties, color };
    }
    return render_properties;
  }, [color, render_properties]);

  const visible = annotation.layer.visible;

  const prevRef = React.useRef({
    id,
    label,
    geometry: rawGeometry,
    paint: rawPaint,
    visible,
  });

  React.useEffect(() => {
    if (geoRef.current) {
      geoRef.current.setVisibility(visible);
    }
  }, [visible]);

  const geometry = equal(rawGeometry, prevRef.current.geometry)
    ? prevRef.current.geometry
    : rawGeometry;

  const paint = equal(rawPaint, prevRef.current.paint)
    ? prevRef.current.paint
    : rawPaint;

  React.useEffect(() => {
    const geo = addGeometry(id, label, geometry, paint, visible);

    geoRef.current = geo;
    prevRef.current = {
      id,
      label,
      geometry,
      paint,
      visible,
    };

    return () => {
      geo.destroy();
    };
  }, [id, label, geometry, paint, visible]);

  return null;
};

export default AnnotationGeometry;
